import { LexicalEditor } from "lexical"

export type LexicalEditorTypes = {
    placeholderText?: string;
    changeStateEditorBody: (htmlContent: string) => void;
    options?: OptionType[];
    messageBody?: string;
    maxLength?: number;
    style?: React.CSSProperties;
    readOnly?: number;
}


export interface LexicalProps {
    editor: LexicalEditor
    disabled?: boolean
    isDropdown?: boolean
}

export interface FormatProps {
    editor: LexicalEditor;
    isDropdown?: boolean;
    active?: boolean;
    readOnly?: boolean
}


export type OptionType =
    | "bold" | "italic" | "edit" | "format" | "underline"
    | "numberList" | "bulletList" | "alignments" | "adjust"
    | "colorPicker" | "bgColorPicker" | "undo" | "redo" | "help" | "clearFormat" | "linkImage";

export interface FormatProps {
    editor: LexicalEditor;
    isDropdown?: boolean;
    active?: boolean;
    blockType?: string;
}

export interface FormatOption {
    component?: React.ComponentType<FormatProps>;
    label?: string;
    width?: string;
    props: FormatProps;
    subItems?: React.ReactNode[];
}

export type ListTypeProps = "bullet" | "circle" | "square" | "number" | "check" | null;

export const toolTipConstants = {
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    bgColorPicker: "Background color",
    edit: "Edit",
    format: "Format",
    numberList: "Numbered list",
    number: "Number",
    lowerAlpha: "Lower alpha",
    lowerGreek: "Lower greek",
    lowerRoman: "Lower roman",
    upperAlpha: "Upper alpha",
    upperRoman: "Upper roman",
    bulletList: "Bullet list",
    default: "Default",
    circle: "Circle",
    square: "Square",
    alignments: "Alignments",
    adjust: "Adjust",
    leftAlign: "Align left",
    centerAlign: "Align center",
    rightAlign: "Align right",
    justifyAlign: "Justify",
    fontColorPicker: "Font color",
    decreaseIndent: "Decrease indent",
    increaseIndent: "Increase indent",
    clearFormat: "Clear formatting",
    undo: "Undo",
    redo: "Redo",
    help: "Help",
    linkImage: "Insert link"
}
